import React from "react";
//import { Link } from "react-router-dom";
//import axios from "axios";
// core components
import { Autocomplete, TextField, FormControl } from "@mui/material";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
//import TextField from '@material-ui/core/TextField';
import api from 'services/api.js';
import { serverApi } from 'services/constante.js';
import LoadingFull from "components/Loading/LoadingFull";
import Icon from "@material-ui/core/Icon";
import CardAvatar from "components/Card/CardAvatar.js";
import Tooltip from '@material-ui/core/Tooltip';
import InputMask from 'react-input-mask';
//import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { ptBR } from "date-fns/locale";
import { format } from "date-fns";

import checaLiberacaoMenu from 'services/checaLiberacaoMenu';
import estados from '../../services/estados.json';
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import ModalInfo from "views/Checkout/Modais/ModalInfo";
import ReviewCadastroMulta from "./ReviewCadastroMulta";
import { FormMultaNaoAcompanhada } from "components/View/Forms/MultaNaoAcompanhada/FormMultaNaoAcompanhada";
//import './styles.css'

export default class MultaNaoAcompanhadaCadastrar extends React.Component {

  constructor(props) {
    super(props);

    checaLiberacaoMenu(props);

    this.state = {
      ProprietarioCondutor: '',
      NomeCompletoDefesa: '',
      CpfDefesa: '',
      //UF: {"Uf": "RJ"},
      EnderecoCompletos: '',
      Placa: '',
      DataInfracao: '',
      formattedDataInfracao: '',
      TelefoneContato: '',
      HoraInfracao: '',
      formatedHoraInfracao: '',
      AutoInfracao: '',
      AutoRenainf: '',
      Enquadramento: '',
      Descricao: '',
      Local: '',
      OrgaoEmissor: '',
      Fase: '',
      SolicitacaoMultaNaoAcompanhada_Id: props.location.state.idPedido,
      Email: localStorage.getItem("CLLogin"),
      function: 'cadastrar_multa',
      props: props,
      templates: [],
      TemplateId: '',
      Sexo: '',
      ReviewCad: false,
      initialStep: null,
    };

    //this.setState({blocking: true});

    var formdata = new FormData();
    formdata.append('function', "templates_nao_acompanhada");

    api.post(serverApi.urlPHP + '/peticao_template.php', formdata).then(response => {

      if (response.data.response == "success") {
        this.setState({ templates: response.data.templates });
      }

    })
      .catch(error => {
        console.error("ERROR", error.response);
        this.setState({ blocking: false });
      })
      .finally(() => {
        this.setState({ blocking: false });
      });


  }

  componentDidMount() { }

  cadastrarVeiculo = (formValues) => {
    // if (!this.validateForm()) {
    //   alert('Todos os campos devem ser preenchidos!');
    //   return;
    // }

    this.setState({
      ...formValues,
      ReviewCad: true,
    });
  };

  validateForm() {
    /* console.log(this.state.Sexo.length, this.state.NomeCompletoDefesa.length, 
            this.state.CpfDefesa.length, this.state.TelefoneContato.length
            ,this.state.EnderecoCompletos.length,this.state.Placa.length
            ,this.state.DataInfracao,this.state.HoraInfracao
            ,this.state.AutoInfracao.length
            ,this.state.Enquadramento.length
            ,this.state.Local.length,this.state.OrgaoEmissor.length
            ,this.state.Fase.length); */
    return this.state.Sexo.length > 0 && this.state.NomeCompletoDefesa.length > 0
      && this.state.CpfDefesa.length > 0 && this.state.TelefoneContato.length > 0
      && this.state.EnderecoCompletos.length > 0 && this.state.Placa.length > 0
      && this.state.formattedDataInfracao.length > 0 && this.state.formatedHoraInfracao.length > 0
      && this.state.AutoInfracao.length > 0
      && this.state.Enquadramento.length > 0
      && this.state.Local.length > 0 && this.state.OrgaoEmissor.length > 0
      && this.state.Fase.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeEnquadramento = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    this.setState({
      ['Enquadramento']: event.target.options[event.target.selectedIndex].text
    });
  }

  handleChangeProprietarioCondutor = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  limpa_formatacao_cpf_cnpj(cpf_cnpj) {
    if (cpf_cnpj.length <= 14) {
      cpf_cnpj = cpf_cnpj.replace(".", "").replace(".", "");
      cpf_cnpj = cpf_cnpj.replace("-", "");
    } else if (cpf_cnpj.length <= 18) {
      cpf_cnpj = cpf_cnpj.replace(".", "").replace(".", "");
      cpf_cnpj = cpf_cnpj.replace("/", "");
      cpf_cnpj = cpf_cnpj.replace("-", "");
    }
    return cpf_cnpj;
  }

  //ESPECÍFICA PARA LIMPAR FORMATAÇÃO DE CPF
  handleChangeCPF = event => {
    let valor = event.target.value;

    let valor_sem_mask = this.limpa_formatacao_cpf_cnpj(valor);
    if (valor_sem_mask.length == 11) {
      valor = valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (valor_sem_mask.length == 14) {
      valor = this.limpa_formatacao_cpf_cnpj(valor);
      valor = valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }

    this.setState({
      [event.target.id]: valor
    });
    /*  this.setState({
       [event.target.id]: event.target.value.replace(".","").replace(".","").replace("-","")
     }); */
  }

  handleChangeData = (newValue) => {

    if (newValue && !isNaN(newValue)) {
      const formattedDate = format(newValue, "dd/MM/yyyy");
      this.setState({ DataInfracao: newValue, formattedDataInfracao: formattedDate });
      console.log('if', newValue);
    } else {
      console.log('else');
      this.setState({ DataInfracao: '', formattedDataInfracao: '' });
    }
  }

  handleSubmit = event => {
    event.preventDefault();
  }

  cancelReview = () => {
    this.setState({
      ReviewCad: false,
      initialStep: 3
    });
  }

  render() {
    return (
      <GridContainer>
        <LoadingFull display={this.state.blocking} />
        {this.state.ReviewCad ?
          <ReviewCadastroMulta 
            data={this.state}
            goBack={this.cancelReview}
          />
          :
          <>
            <FormMultaNaoAcompanhada initialStep={this.state.initialStep} onSubmit={this.cadastrarVeiculo} />
          </>
        }
      </GridContainer>
    );
  }
}